import PublicationShipmentAppService from "../../../../application/platform/publication-shipment/publication-shipment-app-service";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import { useGlobalState } from "../../../global/context/global-context";
import { ACTION_TYPES, useDashboardDispatch } from "./dashboard-context";

export const useDashboardController = () => {
    const { showMessage, showBackDrop } = useBaseLayoutController();
    const dashboardDispatch = useDashboardDispatch();

    const getInit = async () => {
        showBackDrop(true);
        var result = await PublicationShipmentAppService.getDashboard();
        dashboardDispatch({
            type: ACTION_TYPES.setDashboardResponse,
            payload: result,
        });

        showBackDrop(false);

    }

    return {
        getInit
    };
}